import {
    ArrayExpr,
    BinaryExpr,
    CellReference,
    ComparisonExpr,
    ConcatExpr,
    FormulaValueExpression, FrameCalculatedColumnExpr, FrameColumnReference, IdentifierLiteral,
    IntersectionReference,
    InvokeFunctionExpr,
    LazyFormulaExpression, ListReference, LiveFormulaExpression,
    NegateExpr, ParenExpr,
    PercentExpr,
    RangeReference,
    UnionReference,
    ValueLiteral,
} from '@mintdata-wsp/common/controllers/spreadsheet/formula/ast/FormulaASTNodes';
import {IFormulaVisitor} from '@mintdata-wsp/common/controllers/spreadsheet/formula/ast/FormulaVisitor';

export class PrintFormulaAST implements IFormulaVisitor
{
    private _sb:string = '';
    private _indentCount:number = 0;

    public getResult():string
    {
        return this._sb;
    }

    private _print(str:string)
    {
        for( let i = 0; i < this._indentCount; i++ )
            this._sb += '    ';

        this._sb += str + '\n';
    }

    private _indent()
    {
        this._indentCount++;
    }

    private _unindent()
    {
        this._indentCount--;
    }

    cellReference(cellRef:CellReference)
    {
        this._print(`CellReference: ${cellRef.toString()}`);
    }

    rangeReference(range:RangeReference)
    {
        this._print(`RangeReference: ${range.toString()}`);
    }

    intersectionReference(intersection:IntersectionReference)
    {
        this._print(`IntersectionReference: ${intersection.toString()}`);
    }

    unionReference(union:UnionReference)
    {
        this._print(`UnionReference: ${union.toString()}`);
    }

    listReference(list:ListReference)
    {
        this._print(`UnionReference: ${list.toString()}`);
    }

    valueLiteral(value:ValueLiteral)
    {
        this._print(`ValueLiteral: ${value.toString()}`);
    }

    identifierLiteral(identifier:IdentifierLiteral)
    {
        this._print(`IdentifierLiteral: ${identifier.toString()}`);
    }

    preLazyExpr(lazyExpr:LazyFormulaExpression)
    {
        this._print(`Lazy: ${lazyExpr.toString()}`);
    }

    preLiveExpr(liveExpr:LiveFormulaExpression)
    {
        this._print(`Live: ${liveExpr.toString()}`);
    }

    preBinaryExpr(binaryExpr:BinaryExpr)
    {
        this._print(`BinaryExpr: ${binaryExpr.toString()}`);
        this._indent();
    }

    preComparisonExpr(comparisonExpr:ComparisonExpr)
    {
        this._print(`ComparisonExpr: ${comparisonExpr.toString()}`);
        this._indent();
    }

    preConcatExpr(concatExpr:ConcatExpr)
    {
        this._print(`ConcatExpr: ${concatExpr.toString()}`);
        this._indent();
    }

    preInvokeFunction(invokeFuncExpr:InvokeFunctionExpr)
    {
        this._print(`InvokeFunctionExpr: ${invokeFuncExpr.toString()}`);
        this._indent();
    }

    postLazyExpr(lazyExpr:LazyFormulaExpression)
    {
    }

    postLiveExpr(liveExpr:LiveFormulaExpression)
    {
    }

    preNegateExpr(negateExpr:NegateExpr)
    {
        this._print(`NegateExpr: ${negateExpr.toString()}`);
        this._indent();
    }

    prePercentExpr(percentExpr:PercentExpr)
    {
        this._print(`PercentExpr: ${percentExpr.toString()}`);
        this._indent();
    }

    postBinaryExpr(binaryExpr:BinaryExpr)
    {
        this._unindent();
    }

    postComparisonExpr(comparisonExpr:ComparisonExpr)
    {
        this._unindent();
    }

    postConcatExpr(concatExpr:ConcatExpr)
    {
        this._unindent();
    }

    postInvokeFunction(invokeFuncExpr:InvokeFunctionExpr)
    {
        this._unindent();
    }

    postNegateExpr(negateExpr:NegateExpr)
    {
        this._unindent();
    }

    postPercentExpr(percentExpr:PercentExpr)
    {
        this._unindent();
    }

    postFormulaExpr(formulaExpr:FormulaValueExpression)
    {
    }

    preFormulaExpr(formulaExpr:FormulaValueExpression)
    {
    }

    frameCalculatedColumnExpr(frameCalculatedColumn:FrameCalculatedColumnExpr)
    {
        this._print(`FrameCalculatedColumnExpr: ${frameCalculatedColumn.toString()}`);
    }

    frameColumnReference(frameColumn:FrameColumnReference)
    {
        this._print(`FrameColumnReference: ${frameColumn.toString()}`);
    }

    preArrayExpr(array:ArrayExpr)
    {
        this._print(`ArrayExpr: ${array.toString()}`);
        this._indent();
    }

    postArrayExpr(array:ArrayExpr)
    {
        this._unindent();
    }

    preParenExpr(parenExpr:ParenExpr)
    {
        this._print(`ParenExpr: ${parenExpr.toString()}`);
    }

    postParenExpr(parenExpr:ParenExpr)
    {
    }
}
